import { render } from "./InputControlCheckBox.vue?vue&type=template&id=48ce6a32&scoped=true&ts=true"
import script from "./InputControlCheckBox.vue?vue&type=script&lang=ts"
export * from "./InputControlCheckBox.vue?vue&type=script&lang=ts"

import "./InputControlCheckBox.vue?vue&type=style&index=0&id=48ce6a32&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ce6a32"]])

export default __exports__